module.exports = __webpack_public_path__ + "img/index-section6-friend7_a.01fdb9dd.svg";